import { Analytics } from './analytics';
import { ItemRefineSearchAction } from '../item_refine_search/item_refine_search_action';

/// Adobe Analytics 非同期中小カテゴリー検索用送信クラス
export class AsyncSearchMiddleSmallCategoryAnalytics extends Analytics {
  constructor() {
    super();
    ItemRefineSearchAction.SEND_MIDDLE_SMALL_CATEGORY_SEARCH_EVENT.on((data) => {
      this.run(() => {
        const fName = data.isCategorySSearch
          ? '小カテゴリー検索_非同期'
          : '中カテゴリー検索_非同期';
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: fName,
          events: ['event2', 'event14'],
          categoryLL: window.analyticsData.categoryLL,
          categoryL: window.analyticsData.categoryL,
          categoryM: window.analyticsData.categoryM,
          listDisplayType: window.analyticsData.listDisplayType,
          paging: window.analyticsData.paging,
          sortType: window.analyticsData.sortType,
          searchCondition: window.analyticsData.searchCondition,
          searchSpecCondition: window.analyticsData.searchSpecCondition,
          searchItemSpecVariation: window.analyticsData.searchItemSpecVariation,
          club: {
            server: 'club/pc',
            prop5: fName,
            events: ['event2', 'event14'],
            prop12: window.analyticsData.club.prop12,
            prop13: window.analyticsData.club.prop13,
            prop14: window.analyticsData.club.prop14,
            prop18: window.analyticsData.club.prop18,
            prop19: window.analyticsData.club.prop19,
            prop51: window.analyticsData.club.prop51,
            prop52: window.analyticsData.club.prop52,
            prop57: window.analyticsData.club.prop57,
            eVar88: window.analyticsData.club.eVar88
          },
          soloel: {
            server: 'soloel/pc',
            prop5: fName,
            events: ['event2'],
            prop12: window.analyticsData.soloel.prop12,
            prop13: window.analyticsData.soloel.prop13,
            prop14: window.analyticsData.soloel.prop14,
            prop19: window.analyticsData.soloel.prop19,
            prop51: window.analyticsData.soloel.prop51,
            prop52: window.analyticsData.soloel.prop52,
            prop54: window.analyticsData.soloel.prop54,
            prop57: window.analyticsData.soloel.prop57,
            eVar78: window.analyticsData.soloel.eVar78
          }
        };

        if (data.isCategorySSearch) {
          linkAnalyticsData['categoryS'] = window.analyticsData.categoryS;
          linkAnalyticsData.club['prop15'] = window.analyticsData.club.prop15;
          linkAnalyticsData.soloel['prop15'] = window.analyticsData.soloel.prop15;
        }

        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
}
